import { Direction, Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS, Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { KnownThreadStatus } from '../../../types';
import { dedupeSMSTagsArray } from '../../../utils';

type MatchThreadToSmsArgs = {
  thread: Thread;
  originalSms?: SMS;
  updatedSms?: SMS;
};

const getKnownThreadStatusFromSms = (status: Status, originalStatus: KnownThreadStatus): KnownThreadStatus => {
  if (status === Status.STATUS_ERROR) return KnownThreadStatus.ERROR;
  if (status === Status.STATUS_NEW) return KnownThreadStatus.NEW;
  if (status === Status.STATUS_READ) return KnownThreadStatus.READ;
  return originalStatus;
};

export const matchThreadToSms = ({ thread, originalSms, updatedSms }: MatchThreadToSmsArgs): Thread => {
  const isDifferentSms = originalSms?.id !== updatedSms?.id;
  const smsStatusHasChanged = originalSms?.status !== updatedSms?.status;
  const hasNewErrorStatus = smsStatusHasChanged && updatedSms?.status === Status.STATUS_ERROR;
  const hasNewInboundMessage = isDifferentSms && updatedSms?.direction === Direction.DIRECTION_INBOUND;
  const hasNewOutboundMessage = isDifferentSms && updatedSms?.direction === Direction.DIRECTION_OUTBOUND;

  return {
    ...thread,
    status:
      hasNewOutboundMessage && !updatedSms.autogeneratedBy
        ? KnownThreadStatus.READ
        : smsStatusHasChanged && updatedSms?.status
        ? getKnownThreadStatusFromSms(updatedSms?.status, thread.status as KnownThreadStatus)
        : thread.status,
    actionable: hasNewErrorStatus || hasNewInboundMessage ? true : thread.actionable,
    uniqueTags: dedupeSMSTagsArray([...(thread.uniqueTags ?? []), ...(updatedSms?.tagsDetailed ?? [])]),
    isReplied:
      isDifferentSms && updatedSms?.direction === Direction.DIRECTION_OUTBOUND && !updatedSms?.autogeneratedBy
        ? true
        : thread.isReplied,
    isArchived: isDifferentSms && !updatedSms?.autogeneratedBy ? false : thread.isArchived,
    messages: updatedSms ? [updatedSms] : thread.messages,
  };
};
